import { render, staticRenderFns } from "./RankList.vue?vue&type=template&id=b50eb642&scoped=true&"
import script from "./RankList.vue?vue&type=script&lang=js&"
export * from "./RankList.vue?vue&type=script&lang=js&"
import style0 from "./RankList.vue?vue&type=style&index=0&id=b50eb642&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b50eb642",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VList,VListItem,VListItemAvatar,VListItemContent,VListItemTitle})
